var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.2733 5.17163H7.2439C5.93028 5.17163 4.87524 6.22666 4.87524 7.54028V23.6313C4.87524 24.9449 5.93028 25.9999 7.2439 25.9999H19.2733C20.587 25.9999 21.642 24.9449 21.642 23.6313V7.54028C21.642 6.22666 20.587 5.17163 19.2733 5.17163ZM19.4112 23.8554H7.10254V7.31617H19.4112V23.8554Z","fill":"#000F32","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.23074 2.14454H14.5395V4.35804H16.7702V2.36865C16.7702 1.05503 15.7152 0 14.4015 0H2.36865C1.05503 0 0 1.05503 0 2.36865V18.4596C0 19.7732 1.05503 20.8283 2.36865 20.8283H4.06498V18.6837H2.23074V2.14454Z","fill":"#000F32","key":1})]);
}

Copy.defaultProps = {"width":"22","height":"26","viewBox":"0 0 22 26","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
